import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { Spinner } from 'components/Spinner'

import { resetSubscriptionRefundOfferStatusAction } from 'root-redux/actions/common'
import { REFUND_SUBSCRIPTION } from 'root-redux/actions/user'
import { RefundSubscriptionStatus } from 'root-redux/reducers/common'
import {
  selectActionList,
  selectAppName,
  selectSubscriptionRefundStatus,
} from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { useContactFormNavigation } from 'hooks/useContactFormNavigation'

import { getPageIdFromPathname } from 'helpers/getPageIdFormPathname'

import { APP_COLORS_DATA } from 'modules/unsubscribe/pages/AcceptRefund/constants'

import { eventLogger } from 'services/eventLogger.service'

import errorIcon from 'assets/images/error.png'
import successIcon from 'assets/images/success.png'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'

import { StyledStatusModal as S } from './StatusModal.styles'

export const StatusModal: React.FC = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const dispatch: TAppDispatch = useDispatch()

  const appName = useSelector(selectAppName)
  const fetchingActionsList = useSelector(selectActionList)
  const subscriptionRefundStatus = useSelector(selectSubscriptionRefundStatus)

  const { goToContactForm } = useContactFormNavigation()

  const isRefundSubscriptionInProgress =
    fetchingActionsList.includes(REFUND_SUBSCRIPTION)

  const goToSupportPage = () => {
    const source = getPageIdFromPathname(pathname)
    eventLogger.logContactSupportClicked(source)
    dispatch(resetSubscriptionRefundOfferStatusAction())

    goToContactForm(appName)
  }

  const goToLoginPage = () => {
    goTo(PageId.LOGIN)
  }

  const onSuccessClose = async () => {
    dispatch(resetSubscriptionRefundOfferStatusAction())

    goToLoginPage()
  }

  const renderContent = () => {
    if (subscriptionRefundStatus === RefundSubscriptionStatus.SUCCESS) {
      return (
        <>
          <S.StatusImage src={successIcon} alt="success-icon" />
          <S.Title>{t`extendPlan.modal.success.title`}</S.Title>
          <S.Text>{t`acceptRefund.successText`}</S.Text>
          <S.Button
            backgroundColor={APP_COLORS_DATA[appName]}
            onClick={onSuccessClose}
          >
            {t('extendPlan.modal.success.great')}
          </S.Button>
        </>
      )
    }

    return (
      <>
        <S.StatusImage src={errorIcon} alt="error-icon" />
        <S.Title>{t('extendPlan.modal.error.title')}</S.Title>
        <S.Text>{t('acceptRefund.errorText')}</S.Text>
        <S.Button
          backgroundColor={APP_COLORS_DATA[appName]}
          onClick={goToSupportPage}
        >
          {t('login.contactSupport')}
        </S.Button>
      </>
    )
  }

  return (
    <S.Wrapper isShown={Boolean(subscriptionRefundStatus)}>
      {isRefundSubscriptionInProgress && <Spinner />}
      <S.Content>{renderContent()}</S.Content>
    </S.Wrapper>
  )
}
